import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const A4_WIDTH_MM = 210;
const A4_HEIGHT_MM = 297;
const PAGE_MARGIN_MM = 8;

/** Capture a fixed-width A4 document node and save as PDF. */
export const downloadElementAsA4Pdf = async (
  element,
  fileName = "document.pdf"
) => {
  if (!element) return;

  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: "#ffffff",
    width: element.scrollWidth,
    height: element.scrollHeight,
    windowWidth: element.scrollWidth,
  });

  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "a4",
  });

  const contentWidth = A4_WIDTH_MM - PAGE_MARGIN_MM * 2;
  const contentHeight = A4_HEIGHT_MM - PAGE_MARGIN_MM * 2;
  const imgWidth = contentWidth;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  const imgData = canvas.toDataURL("image/jpeg", 0.92);
  let heightLeft = imgHeight;
  let position = 0;

  pdf.addImage(
    imgData,
    "JPEG",
    PAGE_MARGIN_MM,
    PAGE_MARGIN_MM,
    imgWidth,
    imgHeight
  );
  heightLeft -= contentHeight;

  while (heightLeft > 0) {
    position -= contentHeight;
    pdf.addPage();
    pdf.addImage(
      imgData,
      "JPEG",
      PAGE_MARGIN_MM,
      PAGE_MARGIN_MM + position,
      imgWidth,
      imgHeight
    );
    heightLeft -= contentHeight;
  }

  pdf.save(fileName.endsWith(".pdf") ? fileName : `${fileName}.pdf`);
};

export const A4_PRINT_PAGE_STYLE = `
  @page {
    size: A4 portrait;
    margin: 8mm;
  }
  @media print {
    html, body {
      height: auto !important;
      overflow: visible !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }
    .customer-item-summary-a4 {
      width: 100% !important;
      max-width: 100% !important;
      padding: 0 !important;
    }
  }
`;
